module.exports = __webpack_public_path__ + "img/0324image2.3fa06f65.png";